import React from 'react';

import Moment from 'moment';

import { getUniqueAttributes } from '../../custom_js/getUniqueAttributes';
import ExplanationAttributes
  from './ExplanationAttributes/ExplanationAttributes';
import Film from './Film';
import ScheduleDates from './ScheduleDates';
import ScheduleFilter from './ScheduleFilter';

const ALL_HALLS = "Усі зали"

class Schedule extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFilter: this.props.dates[0],
      formatFilter: null,
      hallFilter: null,
      foo: "bar",
      activeAttributes: [],
      isClearActiveAttributes: false // if equal true -> then all uniqAttrs set isActive = false
    }
    this.setDate = this.setDate.bind(this)
    this.applyFilters = this.applyFilters.bind(this)
    this.getAttrs = this.getAttrs.bind(this)
    this.handleHallFilterChange = this.handleHallFilterChange.bind(this)
    this.handleFormatFilterChange = this.handleFormatFilterChange.bind(this)
    this.callbackUpdatedAttributes = this.callbackUpdatedAttributes.bind(this);
    this.clearAttributeFilters = this.clearAttributeFilters.bind(this);
  }

  setDate(date) {
    this.setState(() => ({ dateFilter: date }))
  }

  handleHallFilterChange(val) {
    this.setState({ hallFilter: this.props.hallsById[val] })
  }

  handleFormatFilterChange(val) {
    this.setState({ formatFilter: this.props.formatsById[val] })
  }



  // componentWillReceiveProps(props) {
  //   this.setState({dateFilter: props.dates[0]})
  // }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.dates.length > 0 && this.props.dates[0] !== nextProps.dates[0]) {
      this.setState(() => ({ dateFilter: nextProps.dates[0] }))
      return true
    }
    if (nextState.dateFilter !== this.state.dateFilter) {
      return true;
    }
    if (nextState.hallFilter !== this.state.hallFilter) {
      return true;
    }
    if (nextState.formatFilter !== this.state.formatFilter) {
      return true;
    }
    if (nextState.activeAttributes !== this.state.activeAttributes) {
      return true;
    }
    if (nextState.isClearActiveAttributes !== this.state.isClearActiveAttributes) {
      return true;
    }
    return false
  }

  applyFilters() {
    var retFilms = []

    for (let film of this.props.films) {
      film.filteredSessions = film.Sessions.filter(session => {
        // initial state - all valid
        let dateValid = true
        let hallValid = true
        let formatValid = true

        // check if valid by date - always
        dateValid = Moment.utc(session.ShowTime).isSame(Moment.utc(this.state.dateFilter), 'day');

        if (this.state.formatFilter) {
          formatValid = false
          for (let attr of session.attributes) {
            if (attr.name === this.state.formatFilter.name) {
              formatValid = true;
              break;
            }
          }
        }

        // check if valid by hall - only if selected in filter
        if (this.state.hallFilter) {
          hallValid = session.hall_number === this.state.hallFilter.id
        }


        let sessionActiveAttrs = true
        if (this.state.activeAttributes.length > 0) {
          const fsa = session.attributes.filter(sessionAttr => {

            // Check if Active Attribute exists in the Session Attributes
            const actAttrInSess = this.state.activeAttributes.find(_actAttr => {
              if (
                _actAttr.name === sessionAttr.name &&
                _actAttr.type === sessionAttr.type &&
                _actAttr.short_name === sessionAttr.short_name &&
                _actAttr.description === sessionAttr.description
              ) {
                return true
              }
              return false
            })

            if (actAttrInSess) {
              return true
            }

            return false
          })

          if (fsa.length === 0) {
            sessionActiveAttrs = false
          }
        }


        return dateValid && hallValid && formatValid && sessionActiveAttrs
      })

      if (film.filteredSessions.length > 0) {
        retFilms.push(film)
      }
    }

    if (this.props.limit) {
      return retFilms.slice(0, 5)
    }

    return retFilms
  }

  // getDerivedStateFromProps(props, state) {
  //   this.props.dates.length > 0 && this.props.dates[0] !== props.dates[0]
  // }

  BuildHallFilter() {
    return <ScheduleFilter
      emptyLabel={ALL_HALLS}
      options={this.props.halls}
      handleFilterChange={this.handleHallFilterChange}
      selectedOption={this.state.hallFilter}
    />;
  }

  BuildFormatFilter() {
    return <ScheduleFilter
      emptyLabel="Усі формати"
      options={this.props.formats}
      handleFilterChange={this.handleFormatFilterChange}
      selectedOption={this.state.formatFilter}
    />;
  }

  /**
   * Get unique attributes by filtered films
   */
  getUniqueAttrByFilms(filteredFilms) {
    const allAttributes = filteredFilms
      .map(_ => _.filteredSessions)
      .flat(1)
      .map(_ => _.attributes)
      .flat(1)

    const uniqAttrs = getUniqueAttributes({ allAttributes })

    return uniqAttrs
  }

  callbackUpdatedAttributes({ attributes = [] } = {}) {
    const activeAttributes = attributes.filter(_ => _.isActive)
    this.setState(() => ({ activeAttributes }))
  }

  /**
   * Get unique attributes by filtered films
   * filteredAttributes
   */
  getAttrs(filteredFilms) {
    let uniqAttrs = this.getUniqueAttrByFilms(filteredFilms)

    uniqAttrs = uniqAttrs.map(_ => ({
      ..._,
      // isActive: _.isActive != undefined ? _.isActive : false, // mock, for selected multiple attributes at once
      isActive: false,
      isDisabled: false, // 2do: remove this attr. Not used
      marginBottom: ''
    }))


    // -- other func
    // For uniqAttrs set the isActive property based on activeAttributes
    uniqAttrs = uniqAttrs.map(_uqAttr => {
      let _item = _uqAttr
      // Знайти унікальний атрибут в активних атрибутах і скопіювати його isActive 
      this.state.activeAttributes.forEach(_actAttr => {
        if (
          _uqAttr.name === _actAttr.name &&
          _uqAttr.type === _actAttr.type &&
          _uqAttr.short_name === _actAttr.short_name &&
          _uqAttr.description === _actAttr.description
        ) {
          _item = _actAttr
        }
      })

      return _item
    })


    // return uniqAttrs.sort((a, b) => a.name.localeCompare(b.name))
    return uniqAttrs
  }

  /* 
    getAttrsWithShowUnusedAttributes(filteredFilms) {
      const allAttributes = this.getUniqueAttrByFilmsAllSessions(this.props.films)
      allAttributes.forEach(_ => _.isDisabled = true)
  
      let uniqAttrs2 = allAttributes.map(_uqAttr => {
        let _item = _uqAttr
        // Знайти унікальний атрибут в активних атрибутах і скопіювати його isActive
        this.getAttrs(filteredFilms).forEach(_actAttr => {
          if (
            _uqAttr.name === _actAttr.name &&
            _uqAttr.type === _actAttr.type &&
            _uqAttr.short_name === _actAttr.short_name &&
            _uqAttr.description === _actAttr.description
          ) {
            _item = _actAttr
          }
        })
  
        return _item
      })
  
      // return uniqAttrs2.sort((a, b) => a.name.localeCompare(b.name))
      return uniqAttrs2
  
      getUniqueAttrByFilmsAllSessions(filteredFilms) {
        const allAttributes = filteredFilms
          .map(_ => _.Sessions)
          .flat(1)
          .map(_ => _.attributes)
          .flat(1)
  
        const uniqAttrs = getUniqueAttributes({ allAttributes })
  
        return uniqAttrs
      }
    }
   */

  clearAttributeFilters() {
    this.setState(() => ({
      isClearActiveAttributes: true,
      activeAttributes: [],
      formatFilter: null,
      hallFilter: null,
    }))
  }

  render() {
    const filteredFilms = this.applyFilters()

    const ExplAttr = () => <ExplanationAttributes
      uniqueAttributes={this.getAttrs(filteredFilms)}
      callbackUpdatedAttributes={this.callbackUpdatedAttributes}
      cssDesktopClassForPage={this.props.cssDesktopClassForPage}
      cssMobileClassForPage={this.props.cssMobileClassForPage} />

    const isShowClearBtn =
      this.state.activeAttributes.length > 0 ||
      this.state.hallFilter ||
      this.state.formatFilter

    const ClearBtn = () => <div
      className='mp__sec__content__button'
      onClick={this.clearAttributeFilters}
      style={{
        opacity: isShowClearBtn ? '' : '0.7',
        display: 'flex',
        flexShrink: '0',
        justifyContent: 'center'
      }}
    >
      Скинути вибір
    </div>

    return (
      <div className="schedule">
        <div className="wd">
          <h2 className="schedule__heading">{this.props.heading}</h2>
          {this.props.showDates && <ScheduleDates dates={this.props.dates} currentDate={this.state.dateFilter} setDate={this.setDate} />}
          <div className="schedule__filters">
            {this.props.showHallFilter && this.BuildHallFilter()}
            {this.props.showFormatFilter && this.BuildFormatFilter()}

            {
              (this.props.showHallFilter && this.props.showFormatFilter)
              && (!this.props.showHallFilter || this.props.showFormatFilter)
              && (this.props.showHallFilter || !this.props.showFormatFilter)
              && <ClearBtn />
            }
            <ExplAttr />
            {!(this.props.showHallFilter && this.props.showFormatFilter) && <ClearBtn />}

          </div>
          <div className="schedule__films">
            {filteredFilms.length === 0 && <h3 className='schedule__film__title'>Немає сеансів</h3>}
            {filteredFilms.map(film =>
              <Film film={film} key={film.Id} handleSessionClick={this.props.handleSessionClick} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Schedule


// WEBPACK FOOTER //
// ./src/components/snippets/Schedule.jsx